import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ai-cursor',
  templateUrl: './ai-cursor.component.html',
  styleUrls: ['./ai-cursor.component.css']
})
export class AiCursorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
